import { render } from "./TimeOutStep3.vue?vue&type=template&id=0bf49241&ts=true"
import script from "./TimeOutStep3.vue?vue&type=script&lang=ts"
export * from "./TimeOutStep3.vue?vue&type=script&lang=ts"

import "./TimeOutStep3.vue?vue&type=style&index=0&id=0bf49241&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__